import React, { Component, useEffect } from 'react';
import LayoutStyle from '../../components/layout/Layout';
import CheckEmailAnimation from '../../components/layout/CheckEmailAnimation';
import { Title, SubtitleH3, ConfirmWrapper, ImageContainer, Img, BorderBox, BoxPadding } from '../../styles';
import useInterval from '@use-it/interval';
// import useInterval from './UseInterval';
import Api from '../../Api/Api';

async function checkVerify(props) {
  const api = new Api();
  const res = await api.checkVerifyStatus(props.email);
  if(res === true) {
    props.handleResponse(res);
  }
};

const WaitingForConfirmation = (props) => {
  const delay = 3000;
  useInterval(() => {checkVerify(props)}, delay);
return (
    <LayoutStyle>
      <ConfirmWrapper>
        <ImageContainer>
          <Img src='https://zervicepoint.com/wp-content/uploads/2019/11/zp_logo_name.svg' />
        </ImageContainer>
      <BorderBox>
        <BoxPadding>
          <Title>
            Thanks for signing up!
            <SubtitleH3>
            Please check your email to verify the request.
            </SubtitleH3>
          </Title>
          <CheckEmailAnimation>
          </CheckEmailAnimation>
        </BoxPadding>
      </BorderBox>
      </ConfirmWrapper>
    </LayoutStyle>
  );
}

export default WaitingForConfirmation;
